<template>
  <div>
    <div class="pages">
      <div class="fac top">
        <logo style="width: 60%;" :is-transparent="false"></logo>
        <div v-if="isCN" class="fac" style="width: 40%;height: 170px;">
          <p class="title">{{ $t('main.followUs') }}</p>
          <img style="cursor: pointer;" @mouseenter="handleMouseMove"  @mouseleave="handleMouseLeave" src="/static/home/wx-g.png" class="wImg" />
          <img v-if="wechatShow" src="/static/home/gzh.jpg" class="gzhwx"  />
        </div>
      </div>
      <div class="footer" :class="{ 'has-privacy-policy': !acceptPrivacyPolicy }">
        <div class="footer-content-column"
             v-for="(item, index) in footerTabs"
             v-if="item.is_menu == 1"
             :key="index"
        >
          <router-link
              :to="{ path: getRoutesPath(item['list_template'], item['identification'], item['id']) }"
          >
            <div class="title">{{ item.name }}</div>
          </router-link>
          <div
              v-for="(v, i) in item.child"
              v-if="item.name == $t('main.productCenter')"
              :key="i"
          >
            <router-link
                :to="{ path: getRoutesPath(v['list_template'], v['identification'], v['id']) }"
            ><p>{{ v.name }}</p>
            </router-link>
          </div>
          <div
              v-for="(v, i) in item.child"
              v-if="item.name != $t('main.productCenter') && v.is_menu == 1"
              :key="i"
          >
            <router-link
                :to="{ path: getRoutesPath(v['list_template'], v['identification'], v['id']) }"
            ><p>{{ v.name }}</p>
            </router-link>
          </div>
        </div>
        <div class="footer-content-column-other">
          <div class="fac">
            <div class="title"> {{ $t('main.serviceHotline') }} </div>
            <div> {{ $t('main.serviceHotlineTime') }} </div>
          </div>
          <p>{{ $t('main.serviceHotlineTel') }}</p>
          <p>{{ $t('main.email') }}：<a :href="'mailto:'+$t('main.emailAddress')+'?subject='+$t('main.emailSubject')">{{ $t('main.emailAddress') }}</a></p>
          <p>{{ $t('main.fax') }}: {{ $t('main.faxNum') }}</p>
          <p v-if="isCN"><a href="http://beian.miit.gov.cn" target="_blank">{{ siteConfig.icpno }}</a></p>
          <p>{{ $t('main.companyAddress') }}</p>
          <p>
            {{ siteConfig.copyright }}
          </p>
        </div>
      </div>
    </div>
    <div class="footer-privacy-policy" v-if="!acceptPrivacyPolicy">
      <p>{{ $t("main.PrivacyPolicy") }}</p>
      <div class="facac">
        <a class="btn" :href=privacyPolicyHttp target="_blank">
          {{ $t("main.Detail") }}
        </a>
        <div class="btn" @click="handleOk()"> OK
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import {reportApi} from "@/api";

export default {
  data() {
    return {
      footerTabs:[],
      privacyPolicyHttp:"/service/term/privacy-policy",
      acceptPrivacyPolicy: false,
      templates: {
        index: "/",
        single_intro: "/about",
        single_map: "/service/map",
        single_term: "/service/term",
        single_contact: "/contact",
        category_product: "/product",
        category_product_more: "/product/more",
        detail_product:"/product/detail",
        category_join: "/contact",
        category_steps: "/service/steps",
        category_news: "/news",
        category_productDirectory: "/service",
        detail_article: "/news/detail",
      },
      mouseX: 0,
      mouseY: 0,
      wechatShow:false
    };
  },
  props: ["siteConfig", "isCN"],
  watch: {
    "$store.state.siteInfo": function() {
      this.getFooterTabs();
    },
    "$store.state.tabs": function() {
      this.getFooterTabs();
    }
  },
  created(){
    this.getFooterTabs();
  },
  methods: {
    handleMouseMove(e){
      this.wechatShow = true;
    },
    // 拼接其他导航（过滤 新闻动态 和 联系我们）
    getFooterTabs() {
      this.acceptPrivacyPolicy = localStorage.getItem("acceptPrivacyPolicy_" + Cookies.get("siteInfo")) === "true";
      if (!localStorage.getItem("navTabs_" + Cookies.get("siteInfo"))
          || !localStorage.getItem("productTypeNav_" + Cookies.get("siteInfo"))) {
        setTimeout(() => {
          this.getFooterTabs();
        }, 500);
      } else {
        let footerTabs = JSON.parse(localStorage.getItem("navTabs_" + Cookies.get("siteInfo")));
        this.footerTabs = footerTabs.filter(item => item.name !== this.$t('main.home') && item.name !== this.$t('main.companyNews') && item.name !== this.$t('main.contactUs'))
      }
    },
    handleOk() {
      localStorage.setItem("acceptPrivacyPolicy_" + Cookies.get("siteInfo"), true);
      this.acceptPrivacyPolicy = true;
    },
    handleMouseLeave(){
      this.wechatShow = false;
    },
    getRoutesPath(template, identification, id) {
      let basePath  = this.templates[template];
      let paramsUrl = '';
      if (identification !== '') {
        paramsUrl = '/'+identification;
      } else if (id !== 'productCenter' && id !== 'index' && id !== '0') {
        paramsUrl = '/'+id;
      } else {
        paramsUrl = '';
      }

      return basePath + paramsUrl;
    }
  }
};
</script>
<style lang="less" scoped>
.gzhwx{
  width: 170px;
  height: 170px;
}
.has-privacy-policy {
  margin-bottom: 120px;
}
.footer-privacy-policy {
  width: 100%;
  height: 120px;
  position: fixed;
  z-index: 9999;
  bottom: 0;
  background: #B8B0D4;
}
.btn {
  height: 2.25rem;
  border-radius: 4px;
  padding: 0 1rem;
  line-height: 2.25rem;
  text-align: center;
  cursor: pointer;
  background: #635796;
  border: 1px solid #635796;
  color: #fff;
}
.btn + .btn {
  margin-left: 1.875rem;
  background: #fff;
  border: 1px solid #fff;
  color: #635796;
}
.pages {
  background: #f5f5f5;
  .top {
    padding: 28px 0 28px;
    border-bottom: 1px solid #ccc;
  }
  .title {
    font-size: 1.1428rem;
    font-weight: bold;
    color: #282727;
  }
  .wImg {
    margin-left: 36px;
    width: 34px;
    height: 28px;
  }
  .footer {
    display: flex;
    padding: 1.857rem 0;
  }
  .footer-content-column {
    width: 16%;
    align-items: flex-start;
    p {
      cursor: pointer;
    }
  }
  .footer-content-column-other {
    width: 52%;
  }
}
@media screen and (max-width: 1400px) {
  .pages {
    padding: 0 2%;
  }
  .footer-privacy-policy {
    padding: 20px 2%;
  }
}
@media screen and (min-width: 1400px) {
  .pages {
    padding: 0 10%;
  }
  .footer-privacy-policy {
    padding: 20px 10%;
  }
}
@media screen and (min-width: 1700px) {
  .pages {
    padding: 0 15%;
  }
  .footer-privacy-policy {
    padding: 20px 15%;
  }
}
</style>
